import { createAction, props } from '@ngrx/store';
import { SectionWWW, Platform } from './general.types';

const KEY = '[GENRAL]';

export const updateIsAuthenticated = createAction(`${KEY} update is authenticated`, props<{ isLoggedIn: boolean }>());

export const updatePlatform = createAction(`${KEY} update platform`, props<{ platform: Platform }>());

export const fetchSectionWWW = createAction(`${KEY} fetch section WWW`);
export const fetchSectionWWWSuccess = createAction(
	`${KEY} fetch section WWW success`,
	props<{ sectionWWW: SectionWWW[] }>(),
);
export const fetchSectionWWWError = createAction(`${KEY} fetch section WWW error`);
